import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, IconButton } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
    border: '1px solid',
  },
  error: {
    backgroundColor: '#fef2f2',
    borderColor: '#fecaca',
    color: '#991b1b',
  },
  success: {
    backgroundColor: '#f0fdf4',
    borderColor: '#bbf7d0',
    color: '#166534',
  },
  info: {
    backgroundColor: '#eff6ff',
    borderColor: '#bfdbfe',
    color: '#1e40af',
  },
  warning: {
    backgroundColor: '#fffbeb',
    borderColor: '#fde68a',
    color: '#92400e',
  },
  icon: {
    marginRight: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
  },
  message: {
    flex: 1,
    fontSize: '0.875rem',
  },
}));

const StatusBar = ({ message, type, onClose }) => {
  const classes = useStyles();
  if (!message) return null;

  const iconMap = {
    error: <ErrorOutlineIcon fontSize="small" />,
    success: <CheckCircleOutlineIcon fontSize="small" />,
    info: <InfoOutlinedIcon fontSize="small" />,
    warning: <InfoOutlinedIcon fontSize="small" />,
  };

  const typeClass = classes[type] || classes.info;

  return (
    <Box className={`${classes.root} ${typeClass}`}>
      <span className={classes.icon}>{iconMap[type] || iconMap.info}</span>
      <Typography className={classes.message}>{message}</Typography>
      {onClose && (
        <IconButton size="small" onClick={onClose} style={{ color: 'inherit' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default StatusBar;
